import { useIntl } from 'react-intl'
import { Control, Controller, DeepMap, FieldError } from 'react-hook-form'

import { TextField, Autocomplete } from '@mui/material'

interface option {
  value: string | number
  label: string
}

type ControlledAutocompleteProps = {
  errors?: DeepMap<any, FieldError>
  input: string
  options: option[]
  control: Control<any>
  defaultValue?: option | null
  label?: string
}

export function ControlledAutocompleteInput({
  errors,
  input,
  options,
  control,
  defaultValue,
  label,
}: ControlledAutocompleteProps) {
  const intl = useIntl()
  return (
    <Controller
      name={input}
      control={control}
      defaultValue={defaultValue ? defaultValue.value : undefined}
      render={({ field: { onChange, value, ref, onBlur } }) => {
        const selectedOption =
          options.find((option) => option.value === value) ||
          defaultValue ||
          null

        const resolvedLabel = label || intl.formatMessage({ id: input })

        return (
          <Autocomplete
            fullWidth
            value={selectedOption}
            options={options}
            getOptionLabel={(option) => (option ? option.label : '')}
            isOptionEqualToValue={(option, selected) =>
              option.value === selected.value
            }
            onChange={(_, option) => onChange(option ? option.value : '')}
            onBlur={onBlur}
            renderInput={(params) => (
              <TextField
                {...params}
                inputRef={ref}
                variant="outlined"
                InputLabelProps={{
                  style: {
                    color: '#464855',
                  },
                }}
                name={input}
                label={resolvedLabel}
                placeholder={resolvedLabel}
                error={!!(errors && errors[input])}
                helperText={
                  errors && errors[input]
                    ? intl.formatMessage({ id: errors[input].message })
                    : undefined
                }
              />
            )}
          />
        )
      }}
    />
  )
}
